import { API_URL } from "../../../../../../constants";
import * as httpNetworking from "../../../../../../httpNetworking";

const VERSION = 0;

export async function getUserCountForMultitenantAppId(data: {
    deploymentId: string;
    deploymentType: "development" | "production";
    appId: string;
}): Promise<{
    count: number;
}> {
    const { deploymentId, deploymentType, appId } = data;

    const options: httpNetworking.GETRequestConfig = {
        params: {
            deploymentId,
            deploymentType
        }
    };

    const url = `${API_URL}/saas/multi-tenancy/connection-uri-domain/${appId}/users/count`;

    const result = await httpNetworking.simpleGETRequest(url, options, VERSION);
    return result.data;
}
